"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultToastActions = exports.TOAST_CATEGORIES = void 0;
const defaultToastActions = exports.defaultToastActions = [{
  id: 'default-hide-action',
  title: 'HIDE'
}];
const TOAST_CATEGORIES = exports.TOAST_CATEGORIES = {
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
  SUCCESS: 'success',
  DANGER: 'danger',
  NEUTRAL: 'neutral'
};